<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import { real_id } from 'src/helpers/interface_helpers';
	//Services
	import { gen2Request } from '../../../services/gen_2_http_reqs';
	//Design system components
	import { Button, Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { SettingRequest } from '../../../types/requests/settings/setting';
	import type { Device } from '../../../types/Device';

	export let device: Device, settings: any;

	const id = real_id(device.id),
		component = 'input:2',
		saveName = async () => {
			waitForResponse = true;
			if (name != settings?.[component]?.name) {
				const res: SettingRequest = await gen2Request(device, `input.SetConfig`, {
					id: 2,
					config: { name },
				});
				if (res?.isok) {
					settings[component].name = name;
					devices_settings.update_devices_settings(id, settings);
				}
				onSettingsResponse(res, device);
			}
			waitForResponse = false;
		};

	let name = settings?.[component]?.name || '',
		waitForResponse = false;
</script>

<Text styleType="body-small" class="mb-s text-capitalize"
	>{$format('sub_title_input_counter_name', {
		default: 'Change your Input name here',
	})}:</Text
>
<Input
	size="m"
	class="mb-s"
	icon="fas fa-gauge-circle-plus"
	label={$format(`plus_uni_counter_input`, {
		default: `Input (2)`,
	})}
	bind:value={name}
	id="input-36z3gjg"
	aria-labelledby="input-36z3gjg"
/>

<Button size="m" class="text-uppercase" width="full" loading={waitForResponse} on:click={saveName}
	>{$format('button_save', { default: 'Save' })}</Button
>
